import { Box } from "@mui/material";
import styled from "styled-components";

export const ProfitContainer = styled(Box)`
    height:300px;
    margin-left:46px;
    padding-right:24px;
`;